import { PosUISettings } from ".";

export const accessUISettings: PosUISettings = {
    servicePosId: {
        visible: false,
    },
    surchargeSku: {
        visible: true,
        title: "Surcharge PLU",
        subTitle: "The Access PLU that represents this surcharge",
    },
    priceListPosId: {
        visible: false,
    },
    taxPosId: {
        visible: false,
    },
};
